<dialog
  id="basic_pop"
  class="pop-up"
  aria-labelledby="pop-up-title"
  aria-describedby="pop-up-description"
  aria-modal="true"
  role="dialog"
  #modal
>
  <div class="pop-up-box w-[100%]">
    <div class="pop-up-box-header">
      <h2 id="pop-up-title" class="text-heading-sm text-heading">
        {{ content.heading }}
      </h2>
      <button
        onclick="basic_pop.close()"
        class="pop-up-box-header-close-button"
        aria-label="Close pop-up"
        tabindex="0"
      >
        <div class="pop-up-box-header-close-button-icon"></div>
      </button>
    </div>
    <div class="pop-up-box-content">
      <div class="grid gap-12 py-8">
        <h3 class="text-label-xl-semibold text-heading">{{ content.title }}</h3>
        <p id="pop-up-description" class="text-body-md text-body-copy py-8">
          {{ content.browserDescription }}
        </p>

        <div class="flex flex-center gap-24 pb-24">
          <a
            class="text-center"
            *ngFor="let browserIcon of content.browserIconValues"
            [attr.href]="
              browserIcon.browserIconLink ? browserIcon.browserIconLink : '#'
            "
            [attr.target]="browserIcon.browserIconTarget ? '_blank' : '_self'"
          >
            <img
              class="h-[64px] w-[64px]"
              [attr.alt]="browserIcon.iconText"
              [attr.srcset]="browserIcon.browserIconLogo"
            />
            <span class="text-label-sm-medium text-body-copy">
              {{ browserIcon.iconText }}
            </span>
          </a>
        </div>

        <div
          class="flex flex-col tablet:flex-row tablet:justify-between tablet:items-center gap-16 py-8"
        >
          <p class="text-body-md text-body-copy">
            {{ content.disclaimerText }}
          </p>
          <button
            class="button button-secondary button-lg"
            (click)="unSupportedBrowserClose()"
          >
            {{ content.ctaLabel }}
          </button>
        </div>
      </div>
      <button
        class="text-label-md-semibold text-link pt-12"
        (click)="toggleBrowserNotSupportedReason()"
      >
        {{ content.footnoteTitle }}
        <span
          [ngClass]="{
            up: browserNotSupportedReason
          }"
        ></span>
      </button>
      <div
        class="text-body-sm text-body-copy"
        *ngIf="browserNotSupportedReason"
        innerHTML="{{ content.footnoteDescription }}"
      ></div>
    </div>
  </div>
  <!-- Backdrop Close Method -->
  <form method="dialog" class="pop-up-backdrop">
    <button aria-label="Close pop-up">Close</button>
  </form>
</dialog>
